import i18n from "i18next"

import {
    de,
    en,
    es,
    fi,
    fr,
    it,
    nl,
    no,
    pl,
    pt,
    ru,
    tr    
} from "./locales"

const options = {
    interpolation: { escapeValue: false },
    debug: true,
    lng: localStorage.getItem("selectedLanguage"),
    resources: {
        en: { common: en },
        fr: { common: fr },
        de: { common: de },
        es: { common: es },
        fi: { common: fi },
        it: { common: it },
        nl: { common: nl },
        no: { common: no },
        pl: { common: pl },
        pt: { common: pt },
        ru: { common: ru },
        tr: { common: tr }
        
    },
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    react: { wait: true }
}

i18n.init(options)

export default i18n
